import { Header } from './components/layout/Header';
import { Seo } from './components/layout/Seo';
import { Footer } from './components/layout/Footer';
import { About } from './components/sections/About';
import { Contact } from './components/sections/Contact';
import { Experience } from './components/sections/Experience';
import { Hero } from './components/sections/Hero';
import { Projects } from './components/sections/Projects';
import { Skills } from './components/sections/Skills';
import { CursorGlow } from './components/ui/CursorGlow';
import { ScrollProgress } from './components/ui/ScrollProgress';

// App composes the portfolio as semantic, independently maintainable sections.
export default function App() {
  return (
    <>
      <Seo />
      <ScrollProgress />
      <CursorGlow />
      <Header />
      <main id="top">
        <Hero />
        <About />
        <Projects />
        <Experience />
        <Skills />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
